export const graph = [
  {
    id: 1,
    text: "محیط‌ امن و‌\nپاک",
  },
  { id: 2, text: "به‌‌روز‌ بودن\nتجهیزات" },
  {
    id: 3,
     text:"تهیه‌ ستاپ‌ آزمایش‌\nتوسط‌\nکاربر"
  },
   {
    id: 4,
     text:"هزینه‌ پایین‌"
  },
  {
    id: 5,
     text:"\nبازخورد‌ فوری‌ و\n تکرار‌\nآزمایش"
  },
  {
    id: 6,
     text:"انجام‌ همزمان‌\nآزمایش‌ توسط‌\nچند‌ نفر"
  },  {
    id: 7,
     text:"دسترسی24 ساعته"
  }
];
